module.exports = __webpack_public_path__ + "img/maestro.736f863e.png";